import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { InvoiceLineItemUpsertDto } from 'src/app/invoices/dto/invoice-line-item-upsert.dto';
import { InvoiceUtilityService } from '../../shared/invoice/invoice-utility/invoice-utility.service';

@Component({
  selector: 'wl-invoice-line-item-details',
  templateUrl: './invoice-line-item-details.component.html',
  styleUrls: ['./invoice-line-item-details.component.less'],
  animations: [
    trigger('slideReveal', [
      state(
        'revealed',
        style({
          overflow: 'hidden',
          height: '*',
        })
      ),
      state(
        'hidden',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      transition('hidden => revealed', animate('400ms ease-in-out')),
      transition('revealed => hidden', animate('400ms ease-in-out')),
    ]),
  ],
    standalone: false
})
export class InvoiceLineItemDetailsComponent implements OnInit, OnChanges {
  @Input() lineItem: InvoiceLineItemUpsertDto;
  @Input() isExpanded = false;

  showDialog = false;
  adjustedAmountDue = 0;
  hasPaymentAdjustments = false;

  constructor(private _invoiceUtilityService: InvoiceUtilityService) {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.lineItem) {
      this.adjustedAmountDue = this._invoiceUtilityService.calculateLineItemAdjustedAmountDue(this.lineItem);
      if (this.lineItem.Payments?.length) {
        this.hasPaymentAdjustments = this.lineItem.Payments.map((x) => x.Adjustments.length).some((x) => x > 0);
      }
    }
  }
}
